function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import FieldWrapper from './FieldWrapper';
import { InputContent } from './styles';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemingContext } from '@doordash/design-language';
import omit from 'lodash.omit';
import pickBy from 'lodash.pickby';

var numberOfLines = function numberOfLines(_ref) {
  var isMultiline = _ref.isMultiline,
      type = _ref.type;

  if (isMultiline && type === 'text') {
    return Number.isInteger(isMultiline) ? isMultiline : 2;
  }

  return 1;
};
/**
 * https://developers.google.com/web/fundamentals/accessibility/semantics-aria/aria-labels-and-relationships
 * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html
 * https://developers.google.com/web/fundamentals/design-and-ui/input/forms/
 */


var RawTextField = function RawTextField(_ref2) {
  var autoFocus = _ref2.autoFocus,
      isDisabled = _ref2.isDisabled,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      _onChange = _ref2.onChange,
      onKeyUp = _ref2.onKeyUp,
      onKeyDown = _ref2.onKeyDown,
      value = _ref2.value,
      label = _ref2.label,
      isLabelHidden = _ref2.isLabelHidden,
      isRequired = _ref2.isRequired,
      error = _ref2.error,
      type = _ref2.type,
      title = _ref2.title,
      description = _ref2.description,
      placeholder = _ref2.placeholder,
      autoComplete = _ref2.autoComplete,
      renderBeforeContent = _ref2.renderBeforeContent,
      renderAfterContent = _ref2.renderAfterContent,
      renderConnectedBefore = _ref2.renderConnectedBefore,
      renderConnectedAfter = _ref2.renderConnectedAfter,
      isMultiline = _ref2.isMultiline,
      isResizeable = _ref2.isResizeable,
      maxLength = _ref2.maxLength,
      minLength = _ref2.minLength,
      size = _ref2.size,
      pattern = _ref2.pattern,
      isRounded = _ref2.isRounded,
      accessibilityDescribedBy = _ref2.accessibilityDescribedBy,
      props = _objectWithoutProperties(_ref2, ["autoFocus", "isDisabled", "onFocus", "onBlur", "onChange", "onKeyUp", "onKeyDown", "value", "label", "isLabelHidden", "isRequired", "error", "type", "title", "description", "placeholder", "autoComplete", "renderBeforeContent", "renderAfterContent", "renderConnectedBefore", "renderConnectedAfter", "isMultiline", "isResizeable", "maxLength", "minLength", "size", "pattern", "isRounded", "accessibilityDescribedBy"]);

  var theme = React.useContext(ThemingContext);
  var propsToForward = pickBy(props, function (propValue, key) {
    return key.startsWith('aria-') || key.startsWith('data-');
  });
  return React.createElement(FieldWrapper, {
    label: label,
    description: description,
    error: error,
    isDisabled: isDisabled,
    isLabelHidden: isLabelHidden,
    renderBeforeContent: renderBeforeContent,
    renderAfterContent: renderAfterContent,
    renderConnectedBefore: renderConnectedBefore,
    renderConnectedAfter: renderConnectedAfter,
    accessibilityDescribedBy: accessibilityDescribedBy,
    size: size,
    isRounded: isRounded
  }, React.createElement(InputContent, _extends({
    theme: theme
  }, propsToForward, {
    tag: isMultiline && type === 'text' ? 'textarea' : 'input',
    title: title,
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value, event);
    },
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    type: type // Only one of `<label>` and `aria-label` should be implemented
    // Using two or more together (e.g., a hidden <label> and a
    // duplicate title attribute) can cause information to be
    // repeated by a screen reader.
    // http://webaim.org/techniques/forms/advanced#hiddenlabel
    ,
    "aria-label": isLabelHidden ? label : null,
    required: isRequired,
    autoComplete: autoComplete,
    disabled: isDisabled,
    autoFocus: autoFocus,
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    numberOfLines: numberOfLines({
      isMultiline: isMultiline,
      type: type
    }),
    maxLength: maxLength,
    minLength: minLength,
    isResizeable: isResizeable,
    inputSize: size,
    pattern: pattern
  })));
};

RawTextField.Sizes = FieldWrapper.Sizes;
RawTextField.propTypes = _objectSpread({}, omit(FieldWrapper.propTypes, ['children']), {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  autoFocus: PropTypes.bool,
  isRequired: PropTypes.bool,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  isMultiline: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  isResizeable: PropTypes.bool,

  /**
   * autoComplete
   * @type {String}
   * Used to provide a hint to the browser how to autofill
   * an input for use in a form
   * https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#inappropriate-for-the-control
   */
  autoComplete: PropTypes.string,
  isRounded: PropTypes.bool,
  accessibilityDescribedBy: PropTypes.string
});
RawTextField.defaultProps = {
  isResizeable: true,
  size: RawTextField.Sizes.Medium,
  isRounded: false
};
export default RawTextField;